import React from 'react';
import Tooltip from 'components/tooltips/Tooltips';
import UseContext from 'hooks/useContext';
import useModal from 'components/modal/useModal';
import { BugIcon } from 'assets/icons';

const BugDL = () => {
  const { sidebarExpanded } = UseContext();
  const { toggle } = useModal();
  const collapsedRail = !sidebarExpanded;

  const handleClick = (e) => {
    e.preventDefault();
    toggle('jira_bug_create');
  };

  const rowCollapsedCenter = collapsedRail
    ? 'justify-center tab:max-ls:justify-center ls:justify-center tab:sidebar-expanded:justify-start'
    : '';
  const itemPadding = collapsedRail
    ? 'px-2 max-tab:px-2 tab:max-ls:px-0 ls:px-0 tab:sidebar-expanded:px-2'
    : 'px-2';

  return (
    <li>
      <Tooltip text="Signaler un bug" disabled={sidebarExpanded} placement="right">
        <button
          type="button"
          onClick={handleClick}
          className={`flex items-center h-[44px] rounded-lg ${itemPadding} py-3 transition duration-150 text-gray-700 bg-transparent hover:bg-gray-100 w-full ${rowCollapsedCenter}`}
        >
          <span className="shrink-0">
            <BugIcon wh={24} color="#374151" />
          </span>
          <span
            className={`ft-sm font-medium truncate ml-4 tab:max-ls:ml-0 tab:sidebar-expanded:ml-4 ${
              collapsedRail
                ? 'max-tab:inline tab:max-ls:hidden ls:hidden ls:sidebar-expanded:inline'
                : ''
            }`}
          >
            Signaler un bug
          </span>
        </button>
      </Tooltip>
    </li>
  );
};

export default BugDL;
